import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "user",
  initialState: {
    email: "",
  },
  reducers: {
    login: (state, action) => {
      state.email = action.payload.email;
    },
    logout: (state) => {
      state.email = "";
    },
  },
});

export const { login, logout } = userSlice.actions;
export const selectEmail = (state) => state.email;
export const selectLoggedInStatus = (state) => Boolean(state.email);

export default userSlice.reducer;
